import moment from "moment";
import React from "react";
import {
	TBFL2Record,
	EBFL2RecordState,
} from "../../../../../redux/app/bfl-2/@types";
import { TBFL2I2 } from "../../../../../redux/app/bfl-2/groups/bfl2-i";
import { marpolUtils } from "../../../../../redux/app/marpol";

import Biofouling2TableRows, { Biofouling2TableColumns } from "../BioTableRows";
import Biofouling2Previewer from "../BiofoulingPreviewer";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2I2PreviewProps = OwnProps;
function BFL2I2Preview(props: BFL2I2PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2I2;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");
	const dateOfOriginalOperation = moment(
		biofoulingRecord.item1.dateOfOriginalOperation,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<>
				<Biofouling2TableRows
					record={biofoulingRecord}
					tableRows={[
						[dateOfOriginalOperation, "I", "-", renderItemMain()],
						[...renderMissedPlaceholder()],
						[null, null, "NOTE", biofoulingRecord.remarks],
					]}
				/>
				{renderMissedRecord()}
			</>
		);
	}

	function renderItemMain() {
		return (
			<h4 className="font-medium uppercase">
				{/*  This entry key/value validation is a quickfix and stopgap solution for vessel arctic, this validation will be
			  refactored and types will be also be corrected */}
				ENTRY PERTAINING TO AN EARLIER MISSED OPERATIONAL ENTRY
				{biofoulingRecord.item1.receiptAttachment &&
				biofoulingRecord.item1.receiptAttachment !== " " ? (
					<>
						<br />
						CORRECTION NOTE:{" "}
						<a
							href={marpolUtils.getAttachmentURL(
								biofoulingRecord.item1.receiptAttachment,
								biofoulingRecord.id,
								biofoulingRecord._rev
							)}
							download={biofoulingRecord.item1.receiptAttachment}
						>
							{" "}
							{biofoulingRecord.item1.receiptAttachment}
						</a>
					</>
				) : null}
			</h4>
		);
	}

	function renderMissedPlaceholder(): Biofouling2TableColumns {
		const canShowPlaceholder =
			biofoulingRecord.item1.isAnMissedEntryRecord &&
			!biofoulingRecord.item1.missedRecord;
		if (!canShowPlaceholder) return [null, null, null, null];

		const content = (
			<h4 className="font-medium text-gray-500 uppercase">
				<div className="flex flex-row items-center justify-center p-6 px-12 font-medium text-center bg-gray-100 border-2 border-gray-400 border-dashed">
					<div>MISSED ENTRY WILL APPEAR HERE</div>
					<span className="ml-6 text-gray-400 bp3-icon bp3-icon-time"></span>
				</div>
			</h4>
		);

		return [
			operationDate,
			<div className="text-gray-500">?</div>,
			<div className="text-gray-500">?</div>,
			content,
		];
	}

	function renderMissedRecord() {
		if (!biofoulingRecord.item1.missedRecord) return null;
		return (
			<Biofouling2Previewer
				biofoulingRecord={{
					...biofoulingRecord.item1.missedRecord,
					selectedDate: biofoulingRecord.selectedDate,
					state: props.isStrikedOff
						? EBFL2RecordState.STRIKED_OFF
						: biofoulingRecord.item1.missedRecord.state,
				}}
			/>
		);
	}

	return renderMain();
}

export default BFL2I2Preview;
